export let NavType;
(function (NavType) {
  NavType["VERTICAL"] = "vertical-nav";
  NavType["HUBLESS"] = "hubless-nav";
  NavType["FALLBACK"] = "fallback-nav";
  NavType["HEADLESS"] = "headless-nav";
})(NavType || (NavType = {}));
export let MenuItemLevel;
(function (MenuItemLevel) {
  MenuItemLevel["PRIMARY"] = "primary";
  MenuItemLevel["SECONDARY"] = "secondary";
  MenuItemLevel["TERTIARY"] = "tertiary";
})(MenuItemLevel || (MenuItemLevel = {}));
export const KNOWN_MISSING_DEFAULT_NAV_TRANSLATIONS_KEY = 'KNOWN_MISSING_DEFAULT_NAV_TRANSLATIONS';
export const KNOWN_MISSING_NAV_TRANSLATIONS_KEY = 'KNOWN_MISSING_DEFAULT_NAV_TRANSLATIONS';
export const SECOND = 1000;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;
export const DAY = HOUR * 24;
export const WEEK = DAY * 7;